import React from 'react';
import { FormControl, MenuItem, Select, Chip, Box, Tooltip, IconButton } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useFestival } from '../../context/FestivalContext';
import { useAuth } from '../../context/AuthContext';

// All festivals are named "Gingham Festival <year>", so we just show the year
// in the switcher. Fall back to parsing the name if `year` isn't populated.
const festivalYear = (f) => {
  if (!f) return '';
  if (f.year) return String(f.year);
  const m = String(f.name || '').match(/\d{4}/);
  return m ? m[0] : f.name || '';
};

// Compact festival switcher. Vendors only ever see/use the active festival
// so the dropdown is hidden for them — but the year chip is shown.
const FestivalSelector = ({ variant = 'compact' }) => {
  const { list, selected, setSelectedId, isReadOnly } = useFestival();
  const { isAdmin } = useAuth();

  if (!selected) return null;

  const chip = (
    <Chip
      size="small"
      color={isReadOnly ? 'default' : 'primary'}
      label={`${festivalYear(selected)}${isReadOnly ? ' (read-only)' : ''}`}
      sx={{ fontWeight: 600 }}
    />
  );

  if (!isAdmin || list.length <= 1 || variant === 'chip') {
    return chip;
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <FormControl size="small" sx={{ minWidth: 110 }}>
        <Select
          value={selected.id}
          onChange={(e) => setSelectedId(Number(e.target.value))}
        >
          {list.map((f) => (
            <MenuItem key={f.id} value={f.id}>
              {festivalYear(f)}
              {f.is_active ? ' (active)' : ''}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Tooltip title="Switch which festival year the UI is viewing. Past festivals are read-only.">
        <IconButton size="small" aria-label="festival selector info">
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {isReadOnly && (
        <Chip size="small" color="warning" variant="outlined" label="read-only" />
      )}
    </Box>
  );
};

export default FestivalSelector;
